import { POSClient } from "./pos";
import { use, utils } from "./utils";

export const defaultExport = {
    utils: utils,
    use,
    POSClient,
};